module.exports = __webpack_public_path__ + "img/france4.7ee34ad4.jpg";